import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex,);

import orderModule from './modules/orders/_store';
import storesModule from './modules/stores/_store';
import storeModule from './modules/store/_store/index';
import userModule from './modules/user/_store';
import applicationModule from './modules/application/_store';
import driversModule from './modules/drivers/_store';
import driverModule from './modules/driver/_store';
import logisticOperatorModule from './modules/logisticOperator/_store';
import logisticOperatorsModule from './modules/logisticOperators/_store';
import franchisesModule from './modules/franchises/_store';
import franchiseModule from './modules/franchise/_store';
import franchiseSummaryModule from './modules/franchiseSummary/_store';
import financialStatusModule from './modules/financialStatus/_store';
import couponsModule from './modules/coupons/_store';
import couponModule from './modules/coupon/_store';
import couponPackagesModule from './modules/couponPackages/_store';
import subscriptionPlansModule from './modules/subscriptionPlans/_store';
import occurrencesModules from './modules/occurrences/_store';
import newStore from './modules/store/_store/new-store';
import campaignsModule from './modules/campaigns/_store';
import campaignModule from './modules/campaign/_store';
import campaignBounds from './modules/campaignBounds/_store';
import cityShowcaseModule from './modules/cityShowcase/_store';
import notificationModule from './modules/notification/_store';
import notificationsModule from './modules/notifications/_store';
import userSettingsModule from './modules/userSettings/_store';

import amplitudeComponent from '@/plugins/amplitudeComponent';

const reinstallAmplitudePlugin = (store,) => {
  store.subscribe(({ type, payload, },) => {
    if (type === 'user/setUser') {
      amplitudeComponent.install(Vue, payload.sub,);

      const userType = payload.businessType === 'Franqueadora' ?
        'OPERATION' :
        'FRANCHISE';
      Vue.prototype.$amplitude.identify('user_type', userType,);
    }
  },);
};

export default new Vuex.Store({
  modules: {
    orders: orderModule,
    stores: storesModule,
    store: storeModule,
    user: userModule,
    application: applicationModule,
    drivers: driversModule,
    driver: driverModule,
    logisticOperator: logisticOperatorModule,
    logisticOperators: logisticOperatorsModule,
    franchises: franchisesModule,
    franchise: franchiseModule,
    franchiseSummary: franchiseSummaryModule,
    financialStatus: financialStatusModule,
    coupons: couponsModule,
    coupon: couponModule,
    couponPackages: couponPackagesModule,
    subscriptionPlans: subscriptionPlansModule,
    newStore: newStore,
    occurrences: occurrencesModules,
    campaigns: campaignsModule,
    campaign: campaignModule,
    campaignBounds: campaignBounds,
    cityShowcase: cityShowcaseModule,
    notification: notificationModule,
    notifications: notificationsModule,
    userSettings: userSettingsModule,
  },
  plugins: [reinstallAmplitudePlugin,],
},);
